export const permissions = {
  methods: {
    hasPermissions(item, permission) {
      if (Array.isArray(item)) {
        item = item.reduce(
          (i, ac) => ({
            permissions: [...(i._permissions || []), ...(ac._permissions || [])]
          }),
          { permissions: [] }
        );
      }
      if (!permission) return true;
      else
        return (
          !!item && !!(item._permissions || []).find(i => i === permission)
        );
    }
  }
};
